import log from 'salvo-lite/log'
import YouTubePlayer from 'youtube-player'

class Video {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._videoTriggerElem = this._elem.querySelector('[data-video-trigger]')
        this._playerElem = this._elem.querySelector('[data-video-player]')
        this._videoID = this._elem.dataset.videoId
        this._player = null
        this._videoSettings = this._playerElem.dataset.videoSettings ? JSON.parse(this._playerElem.dataset.videoSettings) : {}

        this._videoSettings = Object.assign({
            enablejsapi: 1,
            showinfo: 0,
            controls: 0,
            playsinline: 1,
            rel: 0,
            modestbranding: 1,
            fs: 0,
            always_fs: 0,
            dontInit: false
        }, this._videoSettings)
        this._stateNames = {
            '-1': 'unstarted',
            0: 'ended',
            1: 'playing',
            2: 'paused',
            3: 'buffering',
            5: 'video-cued'
        }
        if (!this._videoSettings.dontInit) {
            this.init()
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
    }

    init () {
        log.debug(this.constructor.name, 'Initiating')
        this.loadPlayer()

        this._player.on('ready', () => {
            if (this._videoSettings.muted) this._player.mute()
        })

        this._videoTriggerElem.addEventListener('click', (e) => {
            this._player.playVideo()
            if (this._videoSettings.always_fs) this.goFullScreen()
        })

        this._player.on('stateChange', (e) => {
            for (var key in this._stateNames) {
                if (this._stateNames.hasOwnProperty(key)) this._elem.classList.remove(this._stateNames[key])
            }
            log.debug(this.constructor.name, 'StateChange', e)
            if (this._stateNames[e.data]) {
                this._elem.classList.add(this._stateNames[e.data])

                if (this._stateNames[e.data] === 'playing') {
                    this._elem.classList.add('been-played')
                }
            }
        })
        log.debug(this.constructor.name, 'Initiated')
    }

    loadPlayer () {
        this._player = YouTubePlayer(this._playerElem, {
            width: '1920',
            height: '1080',
            videoId: this._videoID,
            playerVars: this._videoSettings
        })
    }

    goFullScreen () {
        if (this._player) {
            this._player.getIframe().then((iframe) => {
                log.debug(this.constructor.name, 'Iframe', iframe)
                if (iframe.requestFullscreen) {
                    iframe.requestFullscreen()
                } else if (iframe.webkitRequestFullscreen) {
                    iframe.webkitRequestFullscreen()
                } else if (iframe.mozRequestFullScreen) {
                    iframe.mozRequestFullScreen()
                } else if (iframe.msRequestFullscreen) {
                    iframe.msRequestFullscreen()
                }
            })
        }
    }
}

export default Video



// WEBPACK FOOTER //
// ./src/scripts/components/Video.js